import { render, staticRenderFns } from "./formAddEditUser.vue?vue&type=template&id=fbaf55be&scoped=true"
import script from "./formAddEditUser.vue?vue&type=script&lang=js"
export * from "./formAddEditUser.vue?vue&type=script&lang=js"
import style0 from "./formAddEditUser.vue?vue&type=style&index=0&id=fbaf55be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaf55be",
  null
  
)

export default component.exports